import { freezeInDev } from './freeze-in-dev.helper';

/**
 * Returns a new object created by spreading `original` and applying `patch`
 * on top. The original is never mutated. In development the result is frozen
 * via freezeInDev to surface accidental downstream mutations.
 */
export function withPatch<T extends object>(original: T, patch: Partial<T>): T {
  return freezeInDev({ ...original, ...patch });
}
